<div class="modal-wrapper">
  <h2 mat-dialog-title>
    {{this.title}}
  </h2>
  <mat-dialog-content>
    <p>{{this.message}}</p>
  </mat-dialog-content>
  <mat-dialog-actions [ngClass]="(this.no && this.no.length > 0 && this.no != '') ? 'text-right' : 'text-center'">
    <button [ngClass]="(this.no && this.no.length > 0 && this.no != '') ? 'mat-raised-button margin-right-2' : 'mat-raised-button'" (click)="onAgree()">{{this.yes}}</button>
    <button *ngIf="this.no && this.no.length > 0 && this.no != ''" mat-raised-button (click)="onClose()">{{this.no}}</button>
  </mat-dialog-actions>
</div>